import React, { useEffect } from 'react';
import AppRoutes from "./AppRoutes";
import { AuthProvider } from '../core/contexts/AuthContext';
import { MaintenanceProvider } from '../features/system/maintenance/contexts/MaintenanceContext';
import '../styles/vroong.css';

function App() {
    useEffect(() => {
        const setupStatusBar = async () => {
            const statusBarModule = await import('@capacitor/status-bar').catch(() => null);
            const coreModule = await import('@capacitor/core').catch(() => null);

            if (statusBarModule && coreModule?.Capacitor?.isNativePlatform()) {
                statusBarModule.StatusBar.setStyle({ style: statusBarModule.Style.Dark });
                statusBarModule.StatusBar.setBackgroundColor({ color: '#ffffff' });
                statusBarModule.StatusBar.show();
            }
        };

        const setupDeepLinkHandler = async () => {
            const appModule = await import('@capacitor/app').catch(() => null);
            const coreModule = await import('@capacitor/core').catch(() => null);

            if (appModule && coreModule?.Capacitor?.isNativePlatform()) {
                appModule.App.addListener('appUrlOpen', (event: any) => {
                    const url = (() => {
                        try {
                            return new URL(event.url);
                        } catch {
                            return null;
                        }
                    })();
                    
                    if (!url) return;
                    
                    const path = url.host || url.pathname.replace('//', '');
                    const params = url.searchParams || new URLSearchParams(url.search);

                    if (path === 'register') {
                        const token = params.get('token');
                        if (token) {
                            window.location.href = `/register?token=${token}`;
                        }
                    }
                });
            }
        };

        // 앱 업데이트 체크 (강제 업데이트)
        const checkAppUpdate = async () => {
            try {
                const coreModule = await import('@capacitor/core').catch(() => null);

                // 네이티브 플랫폼(Android)에서만 실행
                if (!coreModule?.Capacitor?.isNativePlatform()) {
                    return;
                }

                const { AppUpdate, AppUpdateAvailability } = await import('@capawesome/capacitor-app-update');

                // 업데이트 정보 확인
                const info = await AppUpdate.getAppUpdateInfo();

                // 업데이트 가능한 경우 즉시 업데이트 (전체 화면 UI, 앱 사용 차단)
                if (info.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
                    await AppUpdate.performImmediateUpdate();
                }
            } catch (error) {
                // 업데이트 체크 실패 시 무시 (앱 정상 실행)
            }
        };

        setupStatusBar();
        setupDeepLinkHandler();
        checkAppUpdate();
    }, []);

    return (
        <AuthProvider>
            <MaintenanceProvider>
                <div className="app-container">
                    <AppRoutes />
                </div>
            </MaintenanceProvider>
        </AuthProvider>
    );
}

export default App;
